// actions
import { dispatchSetPermissions } from '$comp/main/root.action'

export default () => {
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)
    dispatchSetPermissions({ mic: 'denied' })
  else if (navigator.permissions)
    navigator.permissions
      .query({ name: 'microphone' })
      .then(permissionStatus => {
        dispatchSetPermissions({ mic: permissionStatus.state })

        // eslint-disable-next-line no-param-reassign
        permissionStatus.onchange = () =>
          dispatchSetPermissions({ mic: permissionStatus.state })
      })
      // firefox doesn't support query on microphone
      .catch(() => dispatchSetPermissions({ mic: 'prompt' }))
  else dispatchSetPermissions({ mic: 'prompt' })
}
